<template>
    <v-col>

        <v-card>
            <div class="mt-3 pl-2 pr-2">

                <v-col class="d-flex" cols="12" sm="3">
                    <v-select :items="opcionesGrafico" item-text=nombre item-value=valor v-model="idGrafico"
                        label="Selecciona Gráfico" outlined></v-select>
                </v-col>
                <!--Leyenda Gráfica-->
                <v-layout class="mt-1">
                    <v-flex xs12>
                        <line-chart 
                            :chart-data="tempGrafico"
                            :tromel="isTromel"
                            :temp1_configuracion="temp1_configuracion"
                            :temp2_configuracion="temp2_configuracion"
                        ></line-chart>
                    </v-flex>
                </v-layout>
            </div>
        </v-card>


        <!-- Datos del histórico -->
        <v-card>
            <v-card-title>Todos los datos del ciclo</v-card-title>
            <!-- Datos del ensayo -->
            <!-- {{ensayo}} -->
            <v-data-table :headers="cabera_ensayo" disable-sort hide-default-footer :items="array_ensayo">
                <template v-slot:[`item.estado`]="{ item }">
                    <div :class="colorEstado ? 'red--text': 'green--text'">
                        {{calcularEstado(item)}}
                    </div>
                </template>

                <template v-slot:[`item.fechahora_ensayo`]="{ item }">
                    {{fecha_formateada(item.fechahora_ensayo)}}
                    
                </template>
                <template v-slot:[`item.t_secado`]="{ item }">
                    {{calcularTiempoSecado(item)}}
                </template>

                <!-- <template v-slot:item.cuerpos_extr="{ item }">
                    <div v-if="item.cuerpos_extr=='false'">NO</div>
                    <div v-else>SI</div>
                </template> -->

            </v-data-table>
        </v-card>
        <v-card>
            <v-card-title>Configuración del ciclo</v-card-title>
            <v-data-table :headers="headersConfiguracion" disable-sort hide-default-footer :items="array_ensayo">
                <template v-slot:[`item.hig1_tiempo_seg`]="{ item }">
                    {{segundosAminutos(item.hig1_tiempo_seg)}}
                </template>
                <template v-slot:[`item.hig2_tiempo_seg`]="{ item }">
                    {{segundosAminutos(item.hig2_tiempo_seg)}}
                </template>
                <template v-slot:[`item.tiempo_fallo_hig1`]="{ item }">
                    {{segundosAminutos(tiempo_fallo_hig1)}}
                </template>
                <template v-slot:[`item.tiempo_fallo_hig2`]="{ item }">
                    {{segundosAminutos(tiempo_fallo_hig2)}}
                </template>
            </v-data-table>

            <v-divider></v-divider>

            <v-data-table dense itemKey="id" :headers="headers" :items="datos">
                <template v-slot:[`item.day`]="{ item }">
                    {{ fecha_formateada(item.date) }}
                </template>


                <template v-slot:[`item.temperatura_salida`]="{ item }">
                    <span>
                        {{ new Intl.NumberFormat('es-ES', {
                        minimumFractionDigits: 0, maximumFractionDigits: 2, style:
                        'unit', unit: 'celsius'
                        }).format(item.temperatura_salida)
                        }}
                    </span>
                </template>
                <template v-slot:[`item.temperatura_tromel`]="{ item }">
                    <span>
                        {{ new Intl.NumberFormat('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2, style:
                        'unit', unit: 'celsius' }).format(item.temperatura_tromel) }}
                    </span>
                </template>
            </v-data-table>
        </v-card>
    </v-col>
</template>
<script>
import LineChart from '../components/LineChart.vue'
import moment from 'moment-timezone';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale,
} from 'chart.js'
ChartJS.register(Title,
    Tooltip,
    LineElement,
    LinearScale,
    PointElement,
    CategoryScale)

export default {
    props: {
        datos: [],
        opciones:[],
        ensayo: {}
    },
    components: {
        LineChart
    },
    data() {
        return {
            cabera_ensayo: [
                { text: "CICLO", align: "center", value: "id_ensayo" },
                { text: "Estado", align: "center", value: "estado" },
                { text: "Nombre", align: "center", value: "nombre" },
                { text: "Fecha", align: "center", value: "fechahora_ensayo" },
                { text: "LOTE MP", align: "center", value: "lote_mp" },
                { text: "LOTE Bolson", align: "center", value: "lote_bolson" },
                { text: "LOTE mem higenizada", align: "center", value: "lote_mem_higenizada" },
                // { text: "Cuerpos extraños", align: "center", value: "cuerpos_extr" },
                { text: "Kg entrada", align: "center", value: "kg_entrada" },
                { text: "Kg salida", align: "center", value: "kg_membrana_t2" },
                { text: "Trabajador", align: "center", value: "worker" },
                { text: "Tiempo secado", align: "center", value: "t_secado" },
            ],
            headers: [
                { text: "Día", align: "center", value: "day" },
                { text: "Fase", align: "center", value: "phase" },
                { text: "T salida", align: "center", value: "temperatura_salida" },
                { text: "T Tromel", align: "center", value: "temperatura_tromel" },
                { text: "Caudal aire", align: "center", value: "caudal_aire" },
            ],
            headersConfiguracion: [
                { text: "Cº Umbral higenización 1", align: "center", value: "hig1_temperatura" },
                { text: "Cº Umbral higenización 2", align: "center", value: "hig2_temperatura" },
                { text: "Tiempo umbral higenización 1", align: "center", value: "hig1_tiempo_seg" },
                { text: "Tiempo umbral higenización 2", align: "center", value: "hig2_tiempo_seg" },
                { text: "Tiempo en fallo higenización 1", align: "center", value: "tiempo_fallo_hig1" },
                { text: "Tiempo en fallo higenización 2", align: "center", value: "tiempo_fallo_hig2" },
            ],
            tiempo_fallo_hig1: 0,
            tiempo_fallo_hig2: 0,
            mensajes: {
                temperaturas: [],
                estados: []
            },
            opcionesGrafico: [
                { nombre: 'Temperatura salida', valor: 1 },
                { nombre: 'Temperatura Tromel', valor: 2 },
                { nombre: 'Caudal aire', valor: 3 },
            ],
            idGrafico: 1,
            colorEstado: true,
            // temp1_configuracion: '65',
            // temp2_configuracion: '90',
        }
    },
    computed: {
        //Información del ensayo
        array_ensayo() {
            return [this.ensayo]
        },
        temp1_configuracion(){
            return this.array_ensayo[0].hig1_temperatura.toString()
        },
        temp2_configuracion(){
            return this.array_ensayo[0].hig2_temperatura.toString()
        },
        //Pintar los puntos en el gráfico    
        tempGrafico() {
            let nuevo = {
                labels:[],
                datasets: [
                    {
                        data: [],
                        segment: {
                            borderColor: ctx => this.choosePhaseColor(ctx),
                        },
                        pointRadius: 0, //No pintar los puntos (para que solo se vea la linea)
                    },
                ]
            }
            
            this.mensajes.temperaturas = this.datos
            if (this.idGrafico == 1) {
                this.mensajes.temperaturas.forEach(element => {
                    let fecha_actual = new Date(element.date.replace('T', ' '));
                    let a = moment(fecha_actual).format('HH:mm:ss')
                    nuevo.datasets[0].data.push({ 'x': a, 'y': element.temperatura_salida, 'fase': element.phase })
                    nuevo.labels.push(a)
                });
            } else if (this.idGrafico == 2) {
                this.mensajes.temperaturas.forEach(element => {
                    let fecha_actual = new Date(element.date.replace('T', ' '));
                    let a = moment(fecha_actual).format('HH:mm:ss')
                    nuevo.datasets[0].data.push({ 'x': a, 'y': element.temperatura_tromel, 'fase': element.phase })
                    nuevo.labels.push(a)
                });
            } else {
                this.mensajes.temperaturas.forEach(element => {
                    let fecha_actual = new Date(element.date.replace('T', ' '));
                    let a = moment(fecha_actual).format('HH:mm:ss')
                    nuevo.datasets[0].data.push({ 'x': a, 'y': element.caudal_aire, 'fase': element.phase })
                    nuevo.labels.push(a)
                });
            }

            return nuevo
        },
        isTromel(){
            return(this.idGrafico == 2)
        }
    },
    methods: {
        fecha_formateada(f) {
            return moment(f).format('YYYY-MM-DD HH:mm:ss')
        },
        getCurretDate() {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
        },
        getDayFromDate(date) {
            // return (new Date(date)).toISOString().substr(0, 10)
            return date.split(' ')[0];
        },
        getHourFromDate(date) {
            // return date.split('T')[1].substring(0, 8);
            return date.split(' ')[1];
        },
        choosePhaseColor: (ctx) => {
            if (ctx.p0.raw.fase == ctx.p1.raw.fase) {
                if ([2].includes(ctx.p1.raw.fase)) return '#FF9800'
                if ([4].includes(ctx.p1.raw.fase)) return '#99ff33'
                else return '#2196F3'
            } else {
                // return '#FF9800'
            }
        },
        calcularTiempoSecado(item) {
            let result = []
            this.datos.map(item => {
                if(item.phase == '2'){
                    result.push(item)
                }
            })

            return this.segundosAminutos(result.length)
        },
        segundosAminutos(duration){   
            // Hours, minutes and seconds
            var hrs = ~~(duration / 3600);
            var mins = ~~((duration % 3600) / 60);
            var secs = ~~duration % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";

            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }

            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;
            return ret;
        },
        calcularEstado(item){
            let segundos_fallo_hig1 = []
            let segundos_fallo_hig2 = []
            this.datos.map(item => {
                //Tiempo en higenizacion 1
                if(item.phase == '3'){
                    if(item.temperatura_tromel < this.ensayo.hig1_temperatura){
                        segundos_fallo_hig1.push(item)
                    }
                }
                if(item.phase == '4'){
                    if(item.temperatura_tromel < this.ensayo.hig2_temperatura){
                        segundos_fallo_hig2.push(item)
                    }
                }
            })
            this.tiempo_fallo_hig1 = segundos_fallo_hig1.length
            this.tiempo_fallo_hig2 = segundos_fallo_hig2.length

            let salida = ''
            salida += segundos_fallo_hig1.length < this.ensayo.hig1_tiempo_seg ? '' : ' HIGENIZACION 1 '
            salida += segundos_fallo_hig2.length < this.ensayo.hig2_tiempo_seg ? '' : ' HIGENIZACION 2 '
            if(salida.length < 1){
                this.colorEstado = false
                salida += 'CORRECTO'
            }
            return salida
        },
    },
    created(){
        this.datos.splice()
    },
}
</script>
<style>
.icono {
    text-align: center;
    font-size: 2em;
}
</style>